import { useContext } from "react";
import { EntryTimeContext } from "../contexts/EntryTimeContext";

function useInitialize() {
  const {setElement, setShowModal} = useContext(EntryTimeContext);
  return () => {
    setElement({});
    setShowModal(true);
  }
}

export default useInitialize;